import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminSidebar from './components/AdminSidebar';
import AdminAdmins from './components/AdminAdmins';
import AdminUsers from './components/AdminUsers';
import AdminInvitationCodes from './components/AdminInvitationCodes';
import AdminSlider from './components/AdminSlider';
import AdminBoxes from './components/AdminBoxes';
import AdminTexts from './components/AdminTexts';
import AdminFeatures from './components/AdminFeatures';
import AdminComplaints from './components/AdminComplaints';
import AdminMessages from './components/AdminMessages';
import AdminSettings from './components/AdminSettings';
import AdminTickets from './components/AdminTickets';
import AdminEmbeds from './components/AdminEmbeds';
import './AdminPanel.css';

const AdminPanel = () => {
  const [activeSection, setActiveSection] = useState('admin-slider');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const renderContent = () => {
    switch (activeSection) {
      case 'admin-slider': return <AdminSlider />;
      case 'admin-boxes': return <AdminBoxes />;
      case 'admin-texts': return <AdminTexts />;
      case 'admin-features': return <AdminFeatures />;
      case 'admin-embeds': return <AdminEmbeds />;
      case 'admin-complaints': return <AdminComplaints />;
      case 'admin-messages': return <AdminMessages />;
      case 'admin-settings': return <AdminSettings />;
      case 'admin-tickets': return <AdminTickets />;
      case 'admin-admins': return <AdminAdmins />;
      case 'admin-users': return <AdminUsers />;
      case 'admin-codes': return <AdminInvitationCodes />;
      default: return <AdminSlider />;
    }
  };

  const getSectionTitle = () => {
    switch (activeSection) {
      case 'admin-slider': return { title: 'Slider', subtitle: 'Ana sayfa slider slaytlarını yönetin' };
      case 'admin-boxes': return { title: 'Kutucuklar', subtitle: 'Ana sayfa resim kutucuklarını yönetin' };
      case 'admin-texts': return { title: 'Metin Bölümleri', subtitle: 'Ana sayfa metin ve resim içeriklerini düzenleyin' };
      case 'admin-features': return { title: 'Özellikler', subtitle: 'Ana sayfa özellikler bölümünü düzenleyin' };
      case 'admin-embeds': return { title: 'Embed / iframe', subtitle: 'HTML embed kodları ekleyin ve yönetin' };
      case 'admin-complaints': return { title: 'Şikayetler', subtitle: 'Kullanıcı şikayetlerini inceleyin ve yönetin' };
      case 'admin-messages': return { title: 'Mesajlar', subtitle: 'İletişim formundan gelen mesajları okuyun' };
      case 'admin-settings': return { title: 'Ayarlar', subtitle: 'Site genel ayarları ve footer düzenlemeleri' };
      case 'admin-tickets': return { title: 'Destek', subtitle: 'Kullanıcı destek taleplerini yönetin' };
      case 'admin-admins': return { title: 'Yöneticiler', subtitle: 'Admin ekleme, düzenleme, silme ve yetkilendirme' };
      case 'admin-users': return { title: 'Kullanıcılar', subtitle: 'Kullanıcı ekleme, silme ve limit düzenleme' };
      case 'admin-codes': return { title: 'Davet Kodları', subtitle: 'Davet kodlarını oluşturun ve yönetin' };
      default: return { title: 'Yönetim Paneli', subtitle: '' };
    }
  };

  const { title, subtitle } = getSectionTitle();

  return (
    <div className="admin-panel">
      <button className="admin-mobile-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {sidebarOpen && <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />}

      <AdminSidebar
        activeSection={activeSection}
        onSectionChange={(section) => { setActiveSection(section); setSidebarOpen(false); }}
        isOpen={sidebarOpen}
        user={user}
        onNavigateDashboard={() => navigate('/gosterge-paneli')}
      />

      <main className="admin-main">
        <div className="admin-main-header">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {renderContent()}
      </main>
    </div>
  );
};

export default AdminPanel;
